import { useCallback, useEffect, useRef, useState } from 'react';

// A deduped/cached refetch can resolve within a frame, collapsing the RefreshControl before its
// spinner ever animates - hold the refreshing state long enough for the user to see feedback.
const MIN_REFRESHING_DURATION_MS = 700;

export const useForceRefresh = (refetch: () => Promise<unknown>) => {
    const [forceRefreshing, setForceRefreshing] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const onRefresh = useCallback(() => {
        setForceRefreshing(true);
        const startedAt = Date.now();
        return refetch().finally(() => {
            const remaining = MIN_REFRESHING_DURATION_MS - (Date.now() - startedAt);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setForceRefreshing(false), Math.max(remaining, 0));
        });
    }, [refetch]);

    return { forceRefreshing, onRefresh };
};
